import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(null); // null=checking, false=anon, {user, memberships}

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setSession(false); return; }
    api.get("/auth/me").then((r) => setSession(r.data)).catch(() => { localStorage.removeItem(TOKEN_KEY); setSession(false); });
  }, []);

  const applySession = (data) => {
    if (data.token) localStorage.setItem(TOKEN_KEY, data.token);
    setSession({ user: data.user, memberships: data.memberships });
  };

  const refresh = async () => { const r = await api.get("/auth/me"); setSession(r.data); return r.data; };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem(TOKEN_KEY);
    setSession(false);
  };

  return <AuthContext.Provider value={{ session, applySession, refresh, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
